// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"1aa15fff","245":"74e6e73f","659":"1f624859"}[chunkId] + ".chunk.css";
};